export default template;
function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (map) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (null == (pug_interp = map) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
    }.call(this, "map" in locals_for_with ?
        locals_for_with.map :
        typeof map !== 'undefined' ? map : undefined));
    ;;return pug_html;}